import { useI18n } from '../i18n';
import { flagSrc, type Country } from '../lib/countries';
import DistanceGame from './DistanceGame';

export default function FlagMode({ endless = false }: { endless?: boolean }) {
  const { t } = useI18n();
  return (
    <DistanceGame
      mode="flag"
      prompt={t.puzzle.flag}
      hideFlags
      endless={endless}
      renderPuzzle={(a: Country) => (
        <img className="puzzle-flag" src={flagSrc(a)} alt="Flag to guess" />
      )}
    />
  );
}
